class Dialog {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Nutrition trigger events
    document.querySelectorAll("[data-dialog-trigger]").forEach((trigger) => {
      trigger.addEventListener("click", this.handleTriggerClick.bind(this));
    });

    // Dialog overlay events
    document.querySelectorAll("[data-dialog-overlay]").forEach((overlay) => {
      overlay.addEventListener("click", this.handleOverlayClick.bind(this));
    });

    // Close button events
    document.querySelectorAll("[data-dialog-close]").forEach((button) => {
      button.addEventListener("click", this.handleCloseClick.bind(this));
    });

    // Keyboard events
    document.addEventListener("keydown", this.handleKeydown.bind(this));
  }

  handleTriggerClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const dialogId = event.currentTarget.getAttribute("data-dialog-trigger");
    this.openDialog(dialogId);
  }

  handleOverlayClick(event) {
    if (event.target.hasAttribute("data-dialog-overlay")) {
      this.closeDialog(event.target);
    }
  }

  handleCloseClick(event) {
    const dialog = event.target.closest("[data-dialog-overlay]");
    if (!dialog) {
      return;
    }

    this.closeDialog(dialog);
  }

  handleKeydown(event) {
    const keyCodeEscape = 27;
    if (event.keyCode !== keyCodeEscape) {
      return;
    }

    const openDialogs = document.querySelectorAll("[data-dialog-overlay]:not(.hidden)");
    openDialogs.forEach((dialog) => this.closeDialog(dialog));
  }

  openDialog(dialogId) {
    const dialog = document.getElementById(dialogId);
    if (!dialog) {
      return;
    }

    dialog.classList.remove("hidden");
    dialog.classList.add("flex");
    document.body.style.overflow = "hidden";
  }

  closeDialog(dialog) {
    dialog.classList.add("hidden");
    dialog.classList.remove("flex");
    document.body.style.overflow = "";
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new Dialog());
} else {
  new Dialog();
}
